import React from 'react';
import { motion } from 'framer-motion';
import { Screen } from '../../types';
import acrossBanner from '../../assets/across-banner.svg';

interface LandingScreenProps {
  screen: Screen;
}

export const LandingScreen: React.FC<LandingScreenProps> = ({ screen }) => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center px-8 py-16">
      {/* Logo - Full Screen Width */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="w-screen -mx-8 mb-12"
      >
        <img 
          src={acrossBanner} 
          alt="Across Banner" 
          className="w-full h-auto"
        />
      </motion.div>

      {/* Description */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="max-w-4xl text-center"
      >
        <p className="text-lg md:text-xl text-black leading-relaxed">
          {screen.description}
        </p>
      </motion.div>
    </div>
  );
};
